module.exports = {

	userSession: 'USER_SESSION',

	API: {
		actions: {
			answer_1: 'ANSWER_1',
			answer_2: 'ANSWER_2',
			answer_3: 'ANSWER_3',
			subscribe: 'SUBSCRIBE',
			extra_round: 'EXTRA_ROUND',
			start_daily: 'START_DAILY',
			cancel_subscribe: 'CANCEL_SUBSCRIBE',
		},
		transactionStatus: {
			fail: 'FAIL',
			success: 'SUCCESS',
			success_trial: 'SUCCESS_TRIAL',
			invalid_state: 'INVALID_STATE',
			already_assigned: 'ALREADY_SIGNED',
			questions_available: 'QUESTIONS_AVAILABLE'
		},
		gameStatus: {
			none: 'NONE',
			waiting_question_answer: 'WAITING_QUESTION_ANSWER',
			waiting_start_day_answer: 'WAITING_START_DAY_ANSWER',
			waiting_extra_round_answer: 'WAITING_EXTRA_ROUND_ANSWER'
		},
		subscriptionStatus: {
			active: 'ACTIVE',
			inactive: 'INACTIVE',
			cancelled: 'CANCELLED',
			in_renew_process: 'IN_RENEW_PROCESS'
		},
		subscriptionType: {
			weekly: 'WEEKLY',
			weekly_first_free: 'WEEKLY_FIRST_FREE',
			weekly_step_down_1: 'WEEKLY_STEP_DOWN_1',
			weekly_step_down_2: 'WEEKLY_STEP_DOWN_2',
			weekly_step_down_3: 'WEEKLY_STEP_DOWN_3',
			weekly_step_down_4: 'WEEKLY_STEP_DOWN_4',
			provision: 'PROVISION',
			extra_round: 'EXTRA_ROUND',
			extra_round_step_down_1: 'EXTRA_ROUND_STEP_DOWN_1',
			extra_round_step_down_free: 'EXTRA_ROUND_STEP_DOWN_FREE',
			promo_cm_integration: 'PROMO_CM_INTEGRATION',
			promo_rbt_integration: 'PROMO_RBT_INTEGRATION',
			daily: 'DAILY',
			daily_first_free: 'DAILY_FIRST_FREE',
			daily_step_down_1: 'DAILY_STEP_DOWN_1'
		}
	},

	activationSteps: {
		unknownUser: 'UNKNOWN_USER',
		newUser: 'NEW_USER',
		newUserValidation: 'NEW_USER_VALIDATION',
		alreadyUser: 'ALREADY_USER',
		alreadyUserValidation: 'ALREADY_USER_VALIDATION',
		newSubscription: 'NEW_SUBSCRIPTION',
		alreadySubscribed: 'ALREADY_SUBSCRIBED'
	},

	gameSteps: {
		waitingAnswer: 'WAITING_ANSWER',
		answerRevision: 'ANSWER_REVISION'
	},

	ticketTypes: {
		claroMusicaSubscription: 'CLARO_MUSICA_SUBSCRIPTION',
		rbtSubscription: 'RBT_SUBSCRIPTION',
		jmRenew: 'JM_RENEW',
		jmSubscription: 'JM_SUBSCRIPTION',
		jmHits: 'JM_HITS'
	},

	consentIds: {
		weekly3d: '668ea542e46c08e4deb3f594ff5dd354',
		weekly7d: 'd25865e90343b14ae574ec60f4b084f5'
	}
};



// WEBPACK FOOTER //
// ../config/constants.js